<div class="icon-container">
  @switch (library) {
    @case (IconLibrary.ionic) {
      <ion-icon [style.height]="height" [style.width]="height" [name]="icon"></ion-icon>
    }
    @case (IconLibrary.material) {
      <mat-icon [style.height]="height" [style.width]="height" [style.font-size]="height"> {{ icon }}</mat-icon>
    }
  }
</div>
